<template>
  <BaseModalConfirm
    ref="BaseModalConfirmRef"
    :svg="{ name: 'common/warning', style: { color: 'var(--warning-500)' } }"
    :title="$tc('regAuthForgot.regBonus.modal.noBonus.title')"
    :text="$tc('regAuthForgot.regBonus.modal.noBonus.text')"
    @submit="$emit('no-bonus')"
    @close="onClose"
  >
    <template #controls="{ onSubmit, onCancel }">
      <UiBtn
        :text="$tc('regAuthForgot.regBonus.modal.noBonus.cancel')"
        color="primary"
        @click="onCancel"
      />
      <UiBtn
        :text="$tc('regAuthForgot.regBonus.modal.noBonus.confirm')"
        :data-gtm-id="GA_DEPOSIT_CLOSE_CLICK_BTN_NOBONUS"
        @click="onSubmit"
      />
    </template>
  </BaseModalConfirm>
</template>

<script>
import BaseModalConfirm from '@/components/Base/Modal/Confirm'
import { GTM_REG_BONUS } from '~/constants/gtm'
import throttle from 'lodash/throttle'

export default {
  name: 'RegistrationBonusModalNoBonusWarn',
  components: { BaseModalConfirm },
  data() {
    return {
      GA_DEPOSIT_CLOSE_CLICK_BTN_CONTINUE: GTM_REG_BONUS.EVENT.ga_deposit_close_click_btn_continue,
      GA_DEPOSIT_CLOSE_CLICK_BTN_NOBONUS: GTM_REG_BONUS.ID.ga_deposit_close_click_btn_nobonus,
    }
  },
  methods: {
    async $asyncOpen() {
      return await this.$refs.BaseModalConfirmRef.$asyncOpen()
    },
    addGtmEvent() {
      this.$gtm.push({ event: this.GA_DEPOSIT_CLOSE_CLICK_BTN_CONTINUE })
    },
    /** Додав throttle для методу як тимчасове рішення так як буває подвійний емітінг close модальних вікон */
    onClose: throttle(function() {
      this.addGtmEvent()
    }, 1000, { trailing: false }),
  },
}
</script>
